import React, { useEffect } from "react";
import { Intercom } from "@intercom/messenger-js-sdk";
import { IIntercomSelector } from "./intercom.interface";
import { jivoSelector } from "./intercom.selector";
import { useAppSelector } from "../../store/hooks/store.hooks";
import { useTranslation } from "react-i18next";

export const IntercomComponent = () => {
  const { i18n } = useTranslation();
  const { email, phone, id, name, auth }: IIntercomSelector =
    useAppSelector(jivoSelector);

  useEffect(() => {
    if (auth) {
      Intercom({
        app_id: "sy22pokc",
        hide_default_launcher: true,
        language_override: i18n.language,
        email,
        name,
        phone,
        user_id: id,
      });
      return;
    }
    Intercom({
      app_id: "sy22pokc",
      hide_default_launcher: true,
      language_override: i18n.language,
    });
  }, [auth]);
  useEffect(() => {
    if (auth) {
      Intercom({
        app_id: "sy22pokc",
        hide_default_launcher: true,
        language_override: i18n.language,
        email,
        name,
        phone,
        user_id: id,
      });
      return;
    }
    Intercom({
      app_id: "sy22pokc",
      hide_default_launcher: true,
      language_override: i18n.language,
    });
  }, [i18n.language]);
  return null;
};
